import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const hyperEVM = {
  id: 999,
  name: "HyperEVM",
  nativeCurrency: {
    decimals: 18,
    name: "HYPE",
    symbol: "HYPE",
  },
  rpcUrls: {
    default: { http: ["https://rpc.hyperliquid.xyz/evm"] },
  },
  blockExplorers: {
    default: {
      name: "Purrsec",
      url: "https://purrsec.com/",
    },
  },
  testnet: false,
}

export const hyperEvmConfig: StaticEthereumBlockchainConfig = {
  name: hyperEVM.name,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  icon: "/images/blockchains/hyper-liquid.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  unionApi: "https://api.rarible.org",
  basePath: "https://hyperevm-api.rarible.org",
  baseFee: 200,
  chainId: hyperEVM.id,
  blockchain: Blockchain.HYPEREVM,
  chainName: hyperEVM.name,
  exchange: {
    v2: "0x5faf16A85028BE138A7178B222DeC98092FEEF97",
    wrapper: "0xF965237c6b3f89f8C62B45b94097899E3562A830",
  },
  transferProxies: {
    nft: "0xF65eF65a95821A16E02973b1C2200FA58898e3c0",
    erc721Lazy: "0xce4bf732f53A76C463aE8822be858017b02779c8",
    erc20: "0x248B46BEB66b3078D771a9E7E5a0a0216d0d07ba",
  },
  blockExplorers: [
    {
      url: "https://purrsec.com",
      icon: "/images/scanner.svg",
      adress: "https://purrsec.com/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "hyperevm-node",
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("HYPEREVM:0x0000000000000000000000000000000000000000"),
    symbol: "HYPE",
    name: "HYPE",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("HYPEREVM:0x5555555555555555555555555555555555555555"),
    symbol: "WHYPE",
    name: "WHYPE",
    decimals: 18,
  },
  addFundsLink: "https://rarible.com/hyperevm/swap",
  hasStabilityProtocol: true,
  viem: hyperEVM,
}

export const getHyperEvmConfig = (): StaticEthereumBlockchainConfig =>
  hyperEvmConfig
